<template>
    <div id="modal-login" class="modal candidature login" style="display: none;">
        <transition name="fade-q" mode="out-in">
            <div class="login-wrap" key="login" v-if="showLoginPanel">
                <h2 class="titre">
                    <slot name="titre"></slot>
                </h2>
                <form method="post" @submit.prevent="submitLogin()">
                    <div class="wrap-inputs">
                        <div class="form-item">
                            <label for="email-login" class="label">
                                <slot name="email-label"></slot>
                            </label>
                            <input type="text" name="log" id="user_login" v-model="email" required>
                            <p class="mentions">
                                <slot name="email-mentions"></slot>
                            </p>
                        </div>
                        <div class="form-item">
                            <label for="password-login" class="label">
                                <slot name="password-label"></slot>
                            </label>
                            <input type="password" name="pwd" id="user_pass" v-model="password" required>
                            <p class="mentions">
                                <strong><slot name="forgot-label"></slot> </strong>
                                <a href="" @click.prevent="showLoginPanel = false, errors=null, message=null, sendSuccess=false"><slot name="cliquez"></slot></a>
                            </p>
                        </div>
                    </div>
                    <div class="loader-wrap" v-if="loading">
                        <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="messages" :class="{error : !sendSuccess}" v-if="message">
                        <p v-html="message"></p>
                    </div>
                    <div class="messages" :class="{error : !sendSuccess}" v-if="errors">
                        <div v-for="error in errors">
                            <p v-for="item in error" v-html="item"></p>
                        </div>
                    </div>

                    <div class="cta">
                        <input type="hidden" name="redirect_to" :value="redirect"/>
                        <button type="submit" class="btn outline" v-if="!sendSuccess">
                            <slot name="button-label"></slot>
                        </button>
                        <p class="sav"><slot name="sav"></slot></p>
                    </div>
                </form>
            </div>
            <div class="forgot-wrap" key="forget" v-else>
                <a href="" @click.prevent="showLoginPanel = true, errors=null, message=null, sendSuccess=false" class="go-back"><span class="icon-arrow-right"></span><slot name="back"></slot></a>
                <h2 class="titre">
                    <slot name="forgot-label"></slot>
                </h2>
                <p class="interet">
                    <slot name="thanks"></slot>
                </p>
                <div class="loader-wrap" v-if="loading">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <form @submit.prevent="submit" v-if="!loading && sendSuccess === false">
                    <div class="wrap-inputs">
                        <div class="form-item">
                            <label for="email-forget" class="label">
                                <slot name="email-label"></slot>
                            </label>
                            <input type="email" name="log" id="email-forget" v-model="email" required>
                            <p class="mentions">
                                <slot name="email-mentions"></slot>
                            </p>
                        </div>
                    </div>

                    <div class="cta">
                        <input type="hidden" name="redirect_to" :value="redirect"/>
                        <button type="submit" class="btn outline">
                            <slot name="label-recovery-submit"></slot>
                        </button>
                    </div>
                </form>
                <div class="messages" :class="{error : !sendSuccess}" v-if="message">
                    <p v-html="message"></p>
                </div>

            </div>
        </transition>
    </div>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"

    export default {
        props: {
            isLogged: {
                type: Boolean,
                required: true
            },
            logoutLabel: {
                type: String,
                required: true
            },
            redirect: {
                type: String,
                required: true
            },
        },
        mixins: [Ajax],
        data() {
            return {
                loginUrl: window.taafljd.loginUrl,
                $link: null,
                showLoginPanel: true,
                loading: false,
                message: null,
                sendSuccess: false,
                email: null,
                password:null,
                errors:null
            };
        },
        watch: {
            showLoginPanel(newVal) {
                if (newVal === false) {
                    this.sendSuccess = false
                    this.message = ""
                    this.email = null
                }
            }
        },
        methods: {
            getUserStatus() {

                this.ajax("login", "getUser", {form: this.form}).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.isLogged = data.result;
                        this.updateLinkLabel()
                    } else {
                        console.log("error");
                    }
                });

            },
            submit() {

                let form = {
                    email: this.email,
                };

                this.loading = true

                this.ajaxPost("login", "retrievePassword", {
                    form: form
                }).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.message = data.result.message
                        this.loading = false
                        this.sendSuccess = data.result.success
                    } else {
                        console.log("error");
                        this.loading = false
                    }
                });

            },
            submitLogin(){

                let form = {
                    email: this.email,
                    password: this.password,
                    redirect: this.redirect
                };

                this.loading = true

                this.ajaxPost("login", "login", {
                    form: form
                }).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.message = data.result.message
                        this.errors = data.result.errors
                        this.loading = false
                        this.sendSuccess = data.result.success

                        if (data.result.success){
                            setTimeout(function () {
                                window.location = data.result.redirect
                            },500)
                        }

                    } else {
                        console.log("error");
                        this.loading = false
                    }
                });

            },
            updateLinkLabel() {
                if (this.isLogged) {
                    this.$link.html(this.logoutLabel)
                }
            },
            handleClick(){
                if (!this.isLogged) {
                    $.fancybox.open({
                        src: "#modal-login",
                        type: "inline",
                        autoFocus: false,
                        afterClose: function( instance, slide ) {
                            $("#footer-nav").val('')
                        }
                    });
                }else{
                    window.location = window.taafljd.logoutUrl
                }
            },
            init(){
                this.$link = $(".menu-footer-menu-container .acces-prive a")

                this.updateLinkLabel()

                this.$link.on("click",  (event)=> {
                    event.preventDefault()

                    this.handleClick()

                })
            },
            offInit(){
                this.$link = $(".menu-footer-menu-container .acces-prive a")
                this.$link.off("click")
            }
        },
        mounted() {
            this.offInit()
            this.init()
            $(window).bind("resizeEndThrottle", () => {
                this.offInit()
                this.init()
            });
        },
        destroyed() {
        }
    };
</script>
